import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { UserRole } from '../../model/UserRole'
import { AppRoutes } from '../../routes'
import { useAppState, useDispatchHook } from '../../state/store'

import { SwapHoriz } from '@mui/icons-material'
import messages from './ChangeUserRole.messages'

function ChangeUserRole() {
  const intl = useIntl()
  const SelectLabel = intl.formatMessage(messages.selectLabel)

  const dispatch = useDispatchHook()
  const { role, availableRoles } = useAppState(state => state.session.user)
  const history = useHistory()
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const handleRoleChange = async (requestedRole: UserRole) => {
    setAnchorEl(null)
    history.push(AppRoutes.Home)

    dispatch({
      type: 'Components/ChangeUserRole/Set',
      payload: { requestedRole },
    })
  }

  return (
    <>
      <Tooltip title={SelectLabel}>
        <IconButton
          onClick={event => setAnchorEl(event.currentTarget)}
          aria-label={SelectLabel}
        >
          <SwapHoriz />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {availableRoles?.map((r, index) => (
          <MenuItem
            key={index}
            selected={r === role}
            onClick={() => handleRoleChange(r)}
          >
            {r}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default ChangeUserRole
